import { PageRoute } from 'shared/components';
import { DisbursementContainer, AutopayContainer, ManualDisbursementContainer, ConfirmAccount } from 'components';

const BankRoutes = () => (
  <>
    <PageRoute exact path="/applications/:uuid/bank/disbursement" hasLeaveSurvey>
      <DisbursementContainer />
    </PageRoute>
    <PageRoute exact path="/applications/:uuid/bank/manual-disbursement" hasLeaveSurvey>
      <ManualDisbursementContainer />
    </PageRoute>
    <PageRoute exact path="/applications/:uuid/bank/autopay" hasLeaveSurvey>
      <AutopayContainer />
    </PageRoute>
    <PageRoute exact path="/applications/:uuid/bank/confirm" hasLeaveSurvey>
      <ConfirmAccount />
    </PageRoute>
  </>
);

export default BankRoutes;
